import {parsePhoneNumberFromString} from 'libphonenumber-js/max';

const CANDIDATE = /(^|[^\w+])(\+\d[\d ]{6,18}\d|\d{10,15})(?!\w)/g;

export const formatPhoneNumbersInText = (text: string): string =>
    text.replace(CANDIDATE, (whole: string, before: string, candidate: string) => {
        const digits = candidate.replace(/\s/g, '').replace(/^\+/, '');
        if (digits.length < 9 || digits.length > 15) return whole;
        const parsed = parsePhoneNumberFromString(`+${digits}`);
        return parsed?.isValid() ? `${before}${parsed.formatInternational()}` : whole;
    });
